module.exports = __webpack_public_path__ + "static/img/atm-bersama.e0779fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/atm-bersama.jpg
// module id = 6MsM
// module chunks = 0